/*
Purpose: list details of student with use datatable
Designed by R.Sanjai
Date:24/08/2023 
Project: TCMS
*/

import { useState, useEffect } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import {Row, Col, Card, Modal, Nav, Tab} from "react-bootstrap";

import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import React from "react";

import AddIcon from "@mui/icons-material/Add";
import { ToastContainer, toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import Moment from "moment";
import { security_key, BASE_URL } from "../global";

import { ListSessionTimeTable } from "./ListSessionTime-Table";

import "./Student.css";

function ListSessionTime() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const [showDelete, setDeleteShow] = useState(false);
  const [data_delete, setDeleteLabelData] = useState([]);
  const [isUserDeleteSubmitting, setIsUserDeleteSubmitting] = useState(false);

  const handleDeleteClick = (row) => {
    const updatedData = { ...row };
    setDeleteLabelData(updatedData);

    setDeleteShow(true);
  };

  //Api call start
  const [data, setItems] = useState([]);

  const [records, setRecords] = useState(data);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.post(BASE_URL + "API/api_index.php", {
        security_key: security_key,
        mode: "getAllSessionTime",
        fk_cent_key: sessionStorage.getItem("key"),
      });

      if (response.data.success === true) {
        setRecords(response.data.data);
        setItems(response.data.data);
        setLoading(false);
      } else {
        //alert message provide
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  //Api call End

  const handleMessageDeleteClick = async () => {
    toast.error(
      "Sorry, this session has been enrolled by a student and cannot be deleted.",
      {
        autoClose: 700, // 3 seconds in this example
      }
    );
  };

  function onSubmitUserDelete() {
    setIsUserDeleteSubmitting(true);

    const responseuserdelete = axios
      .post(BASE_URL + "API/api_index.php", {
        security_key: security_key,
        fk_cent_key: sessionStorage.getItem("key"),
        mode: "deleteSessionTime",
        pk_sest_key: data_delete.pk_sest_key,
      })
      .then((responseuserdelete) => {
        if (responseuserdelete.data.data == 1) {
          setDeleteShow(false);
          // Handle the successful response here
          toast.success("Success! Your form was submitted", {
            autoClose: 700, // 3 seconds in this example
          });

          fetchData();

          setIsUserDeleteSubmitting(false);
        } else if (responseuserdelete.data.data == 2) {
          toast.error(
            "Failure! Unable to delete session. student enrolled this session",
            {
              autoClose: 700, // 3 seconds in this example
            }
          );
          fetchData();
          setDeleteShow(false);
          setIsUserDeleteSubmitting(false);
        } else {
          toast.error("Failure! Unable to delete session. Try again later", {
            autoClose: 700, // 3 seconds in this example
          });
          setIsUserDeleteSubmitting(false);
        }
      })
      .catch((error) => {
        // Handle any errors that occurred during the request
        toast.error("Failure! Unable to delete session. Try again later", {
          autoClose: 700, // 3 seconds in this example
        });
        setIsUserDeleteSubmitting(false);
      });
  }

  const [isActive, setIsActive] = useState(true);
  const handleNavTabClick = (event) => {
    setIsActive((isActive) => !isActive);
  };

  const [isPreparing, setIsPreparing] = useState(true);
  const [activeSessionRecords, setActiveSessionRecords] = useState([]);
  const [pastSessionRecords, setPastSessionRecords] = useState([]);

  useEffect(() => {
    setIsPreparing(true);
    const timezone = sessionStorage.getItem("timezone_identifier");
    const today = Moment().tz(timezone).format("YYYY-MM-DD");

    const activeRecords = [];
    const pastRecords = [];
    records?.map ( rec =>{
      const  endDate = Moment(rec.sest_to_date, "YYYY-MM-DD")
      if (endDate.isBefore(today)) {
        pastRecords.push(rec);
      } else {
        activeRecords.push(rec);
      }
    })
    setActiveSessionRecords(activeRecords);
    setPastSessionRecords(pastRecords);
    setIsPreparing(false);
  }, [records])


  return (
    <>
      {/* React alert */}
      <ToastContainer position="top-center" />
      <div className="page-wrapper">
        <Modal show={showDelete} variant="danger">
          <Modal.Header>Delete Session</Modal.Header>

          <Modal.Body>
            <p>
              Are you sure? You want to delete this{" "}
              <b className="bg-warning">session</b>?{" "}
            </p>

            <Card className="rounded-1 mt-2 card-bdr">
              <Card.Body>
                <div>
                  <div className="d-flex justify-content-between align-self-center">
                    <div className="me-5">
                      <div className="">
                        <h6 className="">Session Name:</h6>
                        <p className="ml-3 mb-2">{data_delete.sest_name}</p>
                        <h6>Day:</h6>
                        <p className="ml-3 mb-2">{data_delete.sest_day}</p>
                        <h6>Tutor Name</h6>
                        <p className=" ml-3mb-2">
                          {data_delete.tut_fname +
                            " " +
                            data_delete.tut_surname}
                        </p>
                        <h6>From Date:</h6>
                        <p className=" ml-3 mb-2">
                          {Moment(
                            data_delete.sest_from_date,
                            "YYYY-MM-DD"
                          ).format("DD-MM-YYYY")}
                        </p>
                        <h6>End Date:</h6>
                        <p className=" ml-3 mb-2">
                          {Moment(
                            data_delete.sest_to_date,
                            "YYYY-MM-DD"
                          ).format("DD-MM-YYYY")}
                        </p>
                      </div>
                    </div>
                  </div>
                  <span></span>
                </div>
              </Card.Body>
            </Card>
            <hr />
          </Modal.Body>
          <Modal.Footer className="pt-0">
            <div className="mx-auto d-flex gap-2">
              <Button
                variant="contained"
                className="primary-gray"
                onClick={() => setDeleteShow(false)}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                type="submit"
                className="primary-filled "
                disabled={isUserDeleteSubmitting}
                onClick={() => onSubmitUserDelete()}
              >
                Yes
              </Button>
            </div>
          </Modal.Footer>
        </Modal>

        {/* --------------Page Start--------------- */}

        {/* --------------Section Start--------------- */}

        <div className="mb-3 d-flex justify-content-between align-items-center">
          <div>
            <h5 className="page-title"> Session Times </h5>

            <div role="presentation">
              <Breadcrumbs aria-label="breadcrumb" className="my-breadcrumbs">
                <NavLink underline="hover" color="inherit" to="/calendar">
                  {" "}
                  Home
                </NavLink>

                <Typography color="text.primary">Session</Typography>
              </Breadcrumbs>
            </div>
          </div>
          <div className="d-flex align-items-center gap-2">
            {/*<div>
                            <Button className="secondary-filled " variant="contained" onClick={() => navigate(window.history.back())}>
                                Back
                             </Button>
                         </div>*/}

            <NavLink
              className="primary-filled rounded-10 p-2"
              to="/add-session-time"
            >
              <AddIcon className="btn-icon" /> Create Session Time
            </NavLink>
            {/* <PopupState variant="popover" popupId="demo-popup-menu">
            {(popupState) => (
              <React.Fragment>
                <Button className="primary-filled" variant="contained" {...bindTrigger(popupState)}>
                  New Session Time
                  <ArrowDropDownIcon className='p-0' />
                </Button>
                <Menu {...bindMenu(popupState)}>
                  <MenuItem onClick={() => navigate('/add-session-time')}>Create Session Time</MenuItem>
                </Menu>
              </React.Fragment>
            )}
          </PopupState> */}
          </div>
        </div>
        <Card className="my-card p-1 bg-white">
          <Card.Body>
            {/* -------------Content Start--------------- */}
            <Tab.Container defaultActiveKey="first">
              <Nav variant="pills" className="mb-3 text-dark ">
                <div className="d-flex justify-content-between">
                  <Nav.Item>
                    <Nav.Link eventKey="first"
                              className="px-4 py-2 text-dark me-2"
                              onClick={handleNavTabClick}
                    >
                      Active
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="second"
                              className="px-4 py-2 text-dark"
                              onClick={handleNavTabClick}
                    >
                      Past
                    </Nav.Link>
                  </Nav.Item>
                </div>
              </Nav>
              <Tab.Content>
                <Tab.Pane eventKey="first">
                  <Row>
                    <ListSessionTimeTable records={activeSessionRecords} loading={isPreparing}/>
                  </Row>
                </Tab.Pane>
                <Tab.Pane eventKey="second">
                  <Row>
                    <ListSessionTimeTable records={pastSessionRecords} loading={isPreparing}/>
                  </Row>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>

            {/* --------------Content End--------------- */}
          </Card.Body>
        </Card>

        {/* --------------Section End--------------- */}

        {/* --------------Page End--------------- */}
      </div>
    </>
  );
}

export default ListSessionTime;
